import { combineReducers } from "redux"
import * as reducers from "./reducers"
import { UserInfo } from "pages/auth/types"
import {
  BuildConversationDetail,
  UnreadBuild,
  UnreadConversation,
} from "pages/conversations/conversations.type"
import { modalReducer, ModalState } from "../reducers/modal"
import { LoadingState, loadingReducer } from "../reducers/loading"
import versionDeployReducer, {
  VersionDeployState,
} from "../reducers/version-deploy"
import uploadReducer, { UploadState } from "../reducers/upload-file"

import storage from "redux-persist/lib/storage" // lưu vào localStorage
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist"
import { configureStore as storeToolkit } from "@reduxjs/toolkit"

const rootReducer = combineReducers({
  ...reducers,
  modal: modalReducer,
  loading: loadingReducer,
  versionDeploy: versionDeployReducer,
  upload: uploadReducer,
})

// Step 2: Config persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["versionDeploy"], // chỉ lưu `upload`, các state khác không persist
}
const persistedReducer = persistReducer(persistConfig, rootReducer)
export const configureStore = storeToolkit({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          "modal/openModal",
        ],
        ignoredPaths: ["modal.props.deleteModal.onSubmit"],
      },
    }),
  devTools: process.env.NODE_ENV !== "production",
})
export const persistor = persistStore(configureStore)
export interface RootState {
  userInfo: UserInfo
  unreadBuild: UnreadBuild
  unreadConversation: UnreadConversation
  conversationBuildInfo: BuildConversationDetail[]
  modal: ModalState
  loading: LoadingState
  versionDeploy: VersionDeployState
  upload: UploadState
}
export type AppDispatch = typeof configureStore.dispatch
